<template>
  <div>
    <PageMain
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :totalData="totalData"
      @reload="getData()"
    >
      <template #header>
        <div class="d-flex align-items-stretch">
          <div class="side-frame"></div>
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_header_title_batch') || '订单出货记录' }}
            </span>
          </div>
        </div>
      </template>

      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
  </div>
</template>
<script>
const initPage = { curPage: 1, pageSize: 20, pageTotal: 0 }
import PageMain from './main'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageMain },
  mixins: [EditLoading],
  props: { amzPurchaseCode: { type: String, default: '' } },
  data() {
    return {
      totalData: {},
      tableData: [],
      page: { ...initPage },
      loading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.getData()
    },
    async getData() {
      this.loading = true
      await this.getTableData()
      await this.getTotalData()
      this.loading = false
    },
    async getTableData() {
      if (!this.amzPurchaseCode) return
      const params = { amzPurchaseCode: this.amzPurchaseCode, ...this.page }
      const res = await this.$api
        .ecomAmzFtyPurchaseBatchListApi(params)
        .catch(() => null)
      if (!res) return
      this.tableData = res.body.data
      this.page.pageTotal = res.body.count
      this.page.pageSize = res.body.pageSize
      this.page.curPage = res.body.curPage
    },
    async getTotalData() {
      if (!this.amzPurchaseCode) return
      const params = { amzPurchaseCode: this.amzPurchaseCode }
      const res = await this.$api
        .ecomAmzFtyPurchaseBatchSelectTotalApi(params)
        .catch(() => null)
      this.totalData = res?.body || {}
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
